let cache: Promise<Record<string, string> | undefined> | undefined;

/** DuckDuckGo's bang list (trigger -> URL template), fetched once and memoised. */
export function loadDdgBangs(): Promise<Record<string, string> | undefined> {
  cache ??= fetch('/bangs.json')
    .then(res =>
      res.ok ? (res.json() as Promise<Record<string, string>>) : undefined
    )
    .catch(() => undefined)
    .then(map => {
      if (!map) cache = undefined; // allow a retry later
      return map;
    });
  return cache;
}

export async function lookupDdgBang(name: string): Promise<string | undefined> {
  const map = await loadDdgBangs();
  // Own keys only: `!constructor` isn't a bang.
  const template = map && Object.hasOwn(map, name) ? map[name] : undefined;
  return typeof template === 'string' ? template : undefined;
}

/** The site a DuckDuckGo bang goes to (`thesaurus.com`), for saying so. */
export function ddgHost(template: string): string | undefined {
  try {
    return new URL(
      template.replace(/\{\{\{s\}\}\}/g, 'x'),
      'https://duckduckgo.com'
    ).hostname.replace(/^www\./, '');
  } catch {
    return undefined;
  }
}
